import { useMutation } from "react-query";
import http from "infra/http";
import { CriarPostagemForm } from "../typings";

function useSalvarPostagem(id?: string) {
  return useMutation(
    (data: CriarPostagemForm) => {
      const formData = new FormData();
      formData.append("titulo", data.titulo);
      data.descricao && formData.append("descricao", data.descricao);
      data.imagem && formData.append("imagem", data.imagem);
      formData.append("ativo", data.ativo ? "1" : "0");
      data.dataPublicacao &&
        formData.append("dataPublicacao", data.dataPublicacao);
      data.link && formData.append("link", data.link);

      if (!id) {
        return http.post(`/v1/mural`, formData);
      } else {
        return http.put(`/v1/mural/${id}`, formData);
      }
    },
    { retry: false }
  );
}

export default useSalvarPostagem;
